import { useLocation, useParams } from 'react-router-dom';
import { Box, Chip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'Components/ui';

export const AdminScannerBatchShow = () => {
  const { t } = useTranslation('scanner');
  const { batchId } = useParams();
  const { state } = useLocation();

  const result = state || null;

  return (
    <div className="mt-3 px-3" style={{ maxWidth: 600 }}>
      <PageHeader
        title={t('adminBatchShow.title')}
        segments={[
          { label: t('common:breadcrumbs.globalSettings') },
          { label: t('adminBatch.title'), route: '/admin/scanner/batch' },
          { label: t('adminBatchShow.title') },
        ]}
      />

      <p className="text-muted">{t('adminBatchShow.batchId')} <code>{batchId}</code></p>

      {!result && (
        <div className="alert alert-warning">
          {t('adminBatchShow.noData')}
        </div>
      )}

      {result && (
        <Box>
          <Box display="flex" gap={2} mb={3} flexWrap="wrap">
            <Chip label={t('adminBatchShow.chipTotal', { count: result.totalAccounts })} />
            <Chip label={t('adminBatchShow.chipTriggered', { count: result.triggered })} color="success" />
            {result.failed > 0 && (
              <Chip label={t('adminBatchShow.chipFailed', { count: result.failed })} color="error" />
            )}
          </Box>

          <div className="alert alert-success d-flex align-items-center gap-2">
            <CheckCircleOutlineIcon color="success" />
            <span>
              {t('adminBatchShow.completed')}{' '}
              <strong>{result.triggered}</strong>{' '}
              {t('adminBatchShow.scansTriggered', { count: result.triggered })}{' '}
              {t('adminBatchShow.availability')}
            </span>
          </div>

          {result.triggeredAt && (
            <p className="text-muted mt-2" style={{ fontSize: 13 }}>
              {t('adminBatchShow.triggeredAt')} {new Date(result.triggeredAt).toLocaleString('pt-BR')}
            </p>
          )}
        </Box>
      )}
    </div>
  );
};
